import { LogLevel } from "@azure/msal-browser";
import * as msal from "@azure/msal-browser";
import { env } from './../env';

/**
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_signin",
        // forgotPassword: "B2C_1_forgotpassword",
        // editProfile: "B2C_1_profileedit"
    },
    authorities: {
        signUpSignIn: {
            authority: env.REACT_APP_SIGNIN_AUTH,
        },
        // forgotPassword: {
        //     authority: env.REACT_APP_FORGOTPASSWORD_AUTH,
        // },
        // editProfile: {
        //     authority: env.REACT_APP_EDITPROFILE_AUTH,
        // },
    },
    authorityDomain: env.REACT_APP_AUTHORITY_DOMAIN
}

/**
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: env.REACT_APP_AUTH_CLIENTID, 
        authority: b2cPolicies.authorities.signUpSignIn.authority, 
        knownAuthorities: [b2cPolicies.authorityDomain], 
        redirectUri: "/",
        postLogoutRedirectUri: "/",
        navigateToLoginRequestUrl: false, 
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                        console.warn(message);		
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
//export const loginRequest = {
//    scopes: ["openid", "https://leonardob2ctenant.onmicrosoft.com/demo-api/demo.read"]
//};

export const tokenRequest = {
    scopes: [`${env.REACT_APP_B2C_URL}/demo-api/demo.read`],
    forceRefresh: false
};

export const msalInstance = new msal.PublicClientApplication(msalConfig);

export const applicationRoles = {
    EXTERNAL_CUSTOMER: "External-Customer",
    EXTERNAL_READER: "External-Reader",
    INTERNAL_CUSTOMER_PROJ_PROD: "Internal-Customer-Proj-Prod",
    INTERNAL_READER: "Internal-Reader",
    INTERNAL_CUSTOMER_CS3: "Internal-Customer-CS3"
};

